import React, { useEffect, useState } from "react";
import AddNewFee from "../AddNewFee.component";
import FeeAddedCard from "../FeeAddedCard.component";
import PlusIconBlue from "../../../../../../assets/Icons/Universal/PlusIconWithBlueBack.svg";
import SecondModal from "../../../../../Universal/SecondModal.component";

const OneTimeFeeMainScreen = () => {
  const [editModal, setEditModal] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [addFeeDetails, setAddFeeDetails] = useState([
    {
      enrollment: "Test",
      transactions: [
        { name: "Tuitions", amount: 45 },
        { name: "Medical charges", amount: 45 },
        { name: "Restitution charges", amount: 45 },
        { name: "Software charges", amount: 100 },
      ],
      classes: ["1", "2", "3"],
    },
    {
      enrollment: "Test2",
      transactions: [
        { name: "Tuitions", amount: 45 },
        { name: "Medical charges", amount: 45 },
        { name: "Restitution charges", amount: 45 },
        { name: "Software charges", amount: 45 },
      ],

      classes: ["1", "2", "3"],
    },
  ]);

  const [openAddForm, setOpenAddForm] = useState(false);
  const handelAddData = (data) => {
    setAddFeeDetails((prev) => [...prev, data]);
    setOpenAddForm(false);
  };

  useEffect(() => {
    !addFeeDetails.length > 0 && setOpenAddForm(true);
  }, [addFeeDetails]);
  const handelEditModalData = (index) => {
    setEditModalData(addFeeDetails[index]);
    setEditModal(true);
  };

  const handelEditModalOutputData = (data) => {
    console.log(data);
  };
  return (
    <div className="w-full flex-row align-left justify-start scroll-x">
      <SecondModal isOpen={editModal} isCrossBtn onClose={setEditModal}>
        <div
          className="flex-col align-start justify-start scroll-y"
          style={{ height: "80vh" }}
        >
          <AddNewFee
            formType={"yearly"}
            formTitle={"One time enrollment fees (yearly)"}
            outputData={(data) => handelEditModalOutputData(data)}
            isModal
            data={{ ...editModalData }}
          />
        </div>
      </SecondModal>
      <div className="flex-row align-left justify-start g-1 w-fit">
        {addFeeDetails.map((data, index) => {
          return (
            <FeeAddedCard
              dataType="yearly"
              lightBackColor="var(--blueLight)"
              deepBackColor="var(--blueColor1)"
              color="var(--blueColor1)"
              data={data}
              onEdit={() => handelEditModalData(index)}
            />
          );
        })}
        {openAddForm && (
          <AddNewFee
            formType={"yearly"}
            formTitle={"One time enrollment fees (yearly)"}
            outputData={(data) => handelAddData(data)}
          />
        )}
        {!openAddForm && (
          <button
            type="button"
            onClick={() => setOpenAddForm(true)}
            className="ml-1 w-fit transparentBtn flex-row align-center jsutify-start g-05"
          >
            <img
              src={PlusIconBlue}
              alt=""
              style={{ width: "1.5rem", height: "1.5rem" }}
            />
            <span className="poppins t-14">
              <b>Add another</b>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default OneTimeFeeMainScreen;
